module.exports = __webpack_public_path__ + "static/media/LinkedinIconMin.49139def.svg";